// React
import React, { useState, Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Libraries
import _get from 'lodash/get'

// Components
import BCollectionList from 'store/modules/product/blocks/CollectionList'
import Icon from 'ui/components/Icon'

// Shared
import { setFilterCollection } from 'store/v2/redux/actions/filter'
import CollectionActions from 'store/v2/redux/actions/collection'

const CollectionList = ({
  collections,
  rootCollections,
  active,
  fetchCollections,
  filterKey = 'global',
  brandColor,
  horizontalRule
}) => {
  const [open, setOpen] = useState({})

  useEffect(() => {
    fetchCollections()
  }, [])

  const handleToggleCollection = (collectionId, e) => {
    e?.stopPropagation()

    setOpen((prevOpen) => ({
      ...prevOpen,
      [collectionId]: !prevOpen[collectionId]
    }))
  }

  const handleFilterByCollection = (collectionId, e) => {
    // If collection is closed open it
    if (!open[collectionId]) {
      handleToggleCollection(collectionId)
    }

    e?.nativeEvent.stopImmediatePropagation()
    setFilterCollection(collectionId, filterKey)
  }

  const renderCollection = (collection) => {
    const children = collections.getAll({ parent_id: collection.id })
    const isOpen = !!open[collection.id]
    const hasChildren = children.size() > 0

    return (
      <li key={collection.id}>
        <BCollectionList.Collection
          onClick={(e) => handleFilterByCollection(collection.id, e)}
          bold={hasChildren}
          active={collection.id === active}
          brandingColor={brandColor}
        >
          {hasChildren && (
            <Icon icon={isOpen ? 'minus' : 'plus'} onClick={(e) => handleToggleCollection(collection.id, e)} />
          )}
          <div>{collection.name}</div>
          {' '}
          <span>{collection.item_count}</span>
        </BCollectionList.Collection>

        {hasChildren && isOpen && <BCollectionList>{children.map(renderCollection)}</BCollectionList>}
      </li>
    )
  }

  if (rootCollections.size() === 0) return null

  return (
    <Fragment>
      {horizontalRule && <hr />}
      <div className="bq-sidebar-component">
        <BCollectionList noPadding>{rootCollections.map(renderCollection)}</BCollectionList>
      </div>
    </Fragment>
  )
}

CollectionList.propTypes = {
  collections: PropTypes.object,
  rootCollections: PropTypes.object,
  active: PropTypes.string,
  fetchCollections: PropTypes.func,
  filterKey: PropTypes.string,
  horizontalRule: PropTypes.bool,
  brandColor: PropTypes.string
}

const mapStateToProps = (state, props) => {
  const filter = state.filter.get(props.filterKey || 'global')
  const collections = state.orm.collections.getAll()
  const rootCollections = collections.getAll({ parent_id: null })
  const brandColor = state.settings.get('store.brand_color')

  return {
    active: filter?.get('collection_id'),
    collections,
    rootCollections,
    brandColor
  }
}

const mapDispatchToProps = (_dispatch, _props) => {
  return {
    fetchCollections: () =>
      CollectionActions.fetchAll({
        sort: '-system,depth,position',
        page: {
          size: 1000
        }
      })
  }
}

export default compose(reduxConnect(mapStateToProps, mapDispatchToProps))(CollectionList)
